import React, { useContext, useEffect, useState, useRef } from "react";
import style from "./Modal.module.css";
// import ButtonsModal from "./ButtonsModal/ButtonsModal";
import Button from "../../Button/Button.js";
import { QtdContext } from "../../../context/qtdContext.js";
import { BiTrash } from 'react-icons/bi'
import { useNavigate } from 'react-router-dom';
import $api from '../../../http/index.ts'
import { BACKURL } from '../../../conf.js'
import Loading from 'react-fullscreen-loading';

import { RiDiscountPercentFill } from "react-icons/ri";
import { CiPercent } from "react-icons/ci";
import { confirmAlert } from 'react-confirm-alert'; // Import
import './react-confirm-alert.css'; // Import css
import { ReactNotifications } from 'react-notifications-component'
import 'react-notifications-component/dist/theme.css'
import { Store } from 'react-notifications-component';
import ProgressBar from "@ramonak/react-progress-bar";
import 'animate.css/animate.min.css';
import { BiSolidSave } from "react-icons/bi";
import { RiCheckboxBlankCircleLine } from "react-icons/ri";
import { FiMinusCircle, FiPlusCircle } from "react-icons/fi";
import ComfirmReportModal from "./ComfirmReportModal.js";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { FcOk, FcUp } from "react-icons/fc";
import { FaMinus } from "react-icons/fa";
import { FaPlus } from "react-icons/fa";
import { MdOutlineRadioButtonUnchecked, MdOutlineCheckCircleOutline, MdAssignmentAdd } from "react-icons/md";
import { FaCheck } from "react-icons/fa6";
import AddContrAgentsRashodModal from "../ContrAgents/AddContrAgentsRashodModal.js";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';
import EditShopIncasationsModal from "../ShopIncasations/EditShopIncasationsModal.js";

const SaleReportSteps = ({ shop, smena, CloseSmenaReturn }) => {
  const { shopvneseneenal, setShopvneseneenal, checkAuth, addCARashod, setAdmin, setShopKassas, setEditShopIncasationsModal, editShopIncasationsModal, incosations, setIncosations, setaddCARashod, saleReports, setSaleReports, contragentsPrihods, contragents, Notify, coffeeMashins, saleReportForms, saleReportSteps, setSaleReportSteps, scladShops, reciepts, shopKassas, sclad, setEditShopModal, admins, setAdmins, smenas, setSmenas, admin } = useContext(QtdContext);
  const [loading, seloading] = useState(false)
  const [allSclad, setAllSclad] = useState(false)
  const [selectSales, setSelectSales] = useState('')
  const [selectRem, setSelectRem] = useState('')
  const [id, setId] = useState('')
  const [summIncasations, setSummIncasations] = useState(0)
  const [summVnesenee, setSummVnesenee] = useState(0)

  const cm = coffeeMashins.find(pr => pr.shop_id == shop.id)
  const cmReciepts = cm.reportsCounters.map(pr => typeof pr == 'string' ? JSON.parse(pr) : pr)
  const ref = useRef(null);
  const kassa = shopKassas.find(pr => pr.shop_id == shop.id)
  // const OpnaEditPrihoModal = (id) => {
  //   setEdit_Id(id)
  //   seteditCARashod(true)
  // }
  const srform = saleReportForms.find(forms => forms.id == shop.slform_id)
  // console.log('srform', srform)
  const ieconStyle = {
    borderRadius: '10px',
    fontWeight: 'bold',
    color: 'white',

    margin: '10px',
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',

    textAlign: 'center',
    height: '40px',
    width: '50px',
    border: 'solid white 3px'
  }
  const nosorted = srform.reciepts.map(forms => {
    const parsedForm = typeof forms == 'string' ? JSON.parse(forms) : forms;
    const cmCounters = cmReciepts.find(pr => (pr.id == parsedForm.id) && parsedForm.kategory == 'Кофемашина')
    // console.log(cmCounters, parsedForm)
    const recip = reciepts.find(rr => rr.id == parsedForm.id)
    // console.log(recip)


    if (cmCounters) {
      const linked = parsedForm.linked.map(link_id => {
        const recip1 = reciepts.find(rr => rr.id == link_id)
        return {
          ...recip1,
          saleqty: 0,
          sold: 0,
          price: recip1.price,
          lostqty: 0,
          lostcomment: '',
          saleqty: 0,
          salecomment: '',
          sale10: 0,
          sale20: 0,
          sale30: 0,
          lostwithoutcup: 0,
          salewithoutcup: 0
        }
      })

      return {
        ...parsedForm,
        price: recip.price,
        oldqty: cmCounters.counter,
        newqty: cmCounters.counter,
        awaited: cmCounters.counter,
        linked: linked,
        saleqty: 0,
        sold: 0,
        lostqty: 0,
        lostcomment: '',
        saleqty: 0,
        salecomment: '',
        sale10: 0,
        sale20: 0,
        sale30: 0,
        lostwithoutcup: 0,
        salewithoutcup: 0
      }
    } else {
      return {
        ...parsedForm,
        price: recip.price,
        oldqty: 0,
        sold: 0,
        newqty: 0,
        awaited: 0,
        saleqty: 0,
        lostqty: 0,
        lostcomment: '',
        saleqty: 0,
        salecomment: '',
        sale10: 0,
        sale20: 0,
        sale30: 0,
        lostwithoutcup: 0,
        salewithoutcup: 0
      }
    }

  })
  const [newSRID, setNewSRID] = useState({
    id: null,
    shop_id: shop.id,
    smena_id: smena.id
  })
  const rashods = contragentsPrihods.filter(pr => pr.smena_id == smena.id && pr.shop_id == shop.id)
  console.log(rashods)
  let summinc = 0
  let sumVnesenee = 0
  const incosationsReport = incosations.filter(pr => pr.smena_id == smena.id && pr.shop_id == shop.id)
  incosationsReport.map(gt => {
    // if (gt.confirm) {
    summinc = Number(summinc) + Number(gt.money)

    // }

  })
  const vneseneeReport = shopvneseneenal.filter(pr => pr.smena_id == smena.id && pr.shop_id == shop.id)
  vneseneeReport.map(gt => {
    // if (gt.confirm) {
    sumVnesenee = Number(sumVnesenee) + Number(gt.money)

    // }

  })
  let on = 0
  let ob = 0
  rashods.map(gt => {
    on = Number(on) + Number(gt.nal)
    ob = Number(ob) + Number(gt.beznal)
  })
  // console.log(summinc, sumVnesenee)

  const [newSR, setNewSR] = useState(nosorted)
  const [allProductTaked, setAllProductTaked] = useState([])

  const [page, setPage] = useState('REPORT')
  const [actionId, setactionId] = useState({})

  const [smenasclad, setSmenaSclad] = useState([])
  // const kassa = thisReport.kassa ? typeof thisReport.kassa == 'string' ? JSON.parse(thisReport.kassa) : thisReport.kassa : {
  //   incosations: [],
  //   //привязать кассу точки
  //   spendnal: on,
  //   spendbeznal: ob,
  //   startweek: 0,
  //   endweek: 0,
  //   ostatok: 0
  // }
  useEffect(() => {
    let arr = []
    for (let t = 0; t < newSR.length; t++) {
      let pr = newSR[t]
      const mainReciept = pr.reciept.map(q => JSON.parse(q))
      for (let i = 0; i < mainReciept.length; i++) {

        arr = [...arr, { ...mainReciept[i], qty: Number(mainReciept[i].qty) * (pr.sold + pr.salewithoutcup + pr.lostwithoutcup + pr.lostqty) }]

      }
      if (pr.linked.length > 0) {
        for (let i2 = 0; i2 < pr.linked.length; i2++) {
          // console.log('количество', pr.linked[i2])
          const mainReciept2 = pr.linked[i2].reciept.map(q => JSON.parse(q))
          for (let i3 = 0; i3 < mainReciept2.length; i3++) {
            arr = [...arr, {
              ...mainReciept2[i3], qty: Number(mainReciept2[i3].qty) * (pr.linked[i2].sold
                // + pr.linked[i2].salewithoutcup + pr.linked[i2].lostqty + pr.linked[i2].lostwithoutcup
              )
            }]

          }
        }
      }
    }
    // const allReciepts = newSR.map(pr => {
    //   // console.log('количество', pr.sold)
    //   const mainReciept = pr.reciept.map(q => JSON.parse(q))
    //   for (let i = 0; i < mainReciept.length; i++) {

    //     arr = [...arr, { ...mainReciept[i], qty: Number(mainReciept[i].qty) * (pr.sold + pr.salewithoutcup + pr.lostqty + pr.lostwithoutcup) }]
    //     if (pr.linked.length > 0) {
    //       for (let i2 = 0; i2 < pr.linked.length; i2++) {
    // console.log('количество', pr.linked[i2])
    //         const mainReciept2 = pr.linked[i2].reciept.map(q => JSON.parse(q))
    //         for (let i3 = 0; i3 < mainReciept2.length; i3++) {
    //           arr = [...arr, {
    //             ...mainReciept2[i3], qty: Number(mainReciept2[i3].qty) * (pr.linked[i2].sold
    //               // + pr.linked[i2].salewithoutcup + pr.linked[i2].lostqty + pr.linked[i2].lostwithoutcup
    //             )
    //           }]

    //         }
    //       }
    //     }
    //   }

    // })
    console.log('arr', arr)
    const summedItems = Object.values(
      arr.reduce((acc, item) => {
        if (!acc[item.prod_id]) {
          acc[item.prod_id] = { ...item };
        } else {
          acc[item.prod_id].qty += item.qty;
        }
        return acc;
      }, {})
    );

    // console.log(summedItems);


    const scladstate = srform.sclad.map(pr => {
      // console.log('в приходе и расходе - смотреть есть ли сохраненый отчет и если нет то создавать')
      const item = typeof pr == 'string' ? JSON.parse(pr) : pr
      const smenaSclad = smena.sclad.map(d => typeof d == 'string' ? JSON.parse(d) : d).find(g => g.prod_id == item.id && g.shop_id == shop.id)
      // return smenaSclad.find(d => d.id == item.id && d.shop_id == shop.id)
      console.log('item', item)
      console.log('smenaSclad', smenaSclad)
      // console.log('dwedwe', item)
      const sc = scladShops.find(d => d.prod_id == Number(item.id) && d.shop_id == Number(shop.id))
      // console.log('Scladtest', sc)
      const rashodReciepts = summedItems.find(pr => Number(pr.prod_id) == Number(item.id))

      const t = rashodReciepts ? rashodReciepts : { qty: 0 }
      // console.log(t)

      if (smenaSclad) {
        // console.log('smenaSclad', smenaSclad)
        const prpr = smenaSclad.prihod ? smenaSclad.prihod : 0
        const prrs = smenaSclad.rashod ? smenaSclad.rashod : 0
        const totalCounter = Number((smenaSclad.scldqty + prpr - prrs - t.qty).toFixed(3))
        // console.log('totalCounter')
        return {
          ...smenaSclad,
          scldqty: smenaSclad.scldqty,
          rashodReciept: Number((Number(t.qty)).toFixed(3)),
          andqty: totalCounter,
          awaited: totalCounter, prihod: prpr, rashod: prrs, comfirm: false
        }
      }
      else {

        const prpr = item.prihod ? item.prihod : 0
        const prrs = item.rashod ? item.rashod : 0
        console.log(sc)
        const totalCounter = Number((sc ? sc.scldqty : 0 + prpr - prrs - t.qty).toFixed(3))
        // console.log('totalCounter')

        return {
          ...item, scldqty: sc ? sc.scldqty : 0, andqty: totalCounter,
          rashodReciept: Number((Number(t.qty)).toFixed(3)),
          awaited: totalCounter, prihod: prpr, rashod: prrs, fact: item.scldqty + prpr - prrs, comfirm: false, andqty: item.scldqty + prpr - prrs
        }
      }




    })
    setAllProductTaked(summedItems)
    setSmenaSclad(scladstate)
    // console.log(scladstate)

  }, [newSR, smenas])
  const deleteRashod = async (id) => {
    try {
      seloading(true)
      const newProd = await $api.post(`${BACKURL}/api/contragentsrashod/delete/${id}`, { smena_id: smena.id, shop_id: shop.id })

      // setAvansReports(avansReports.map(pr => {
      //   if (pr.id == newProd.data.id) {
      //     return newProd.data
      //   } else return pr
      // }))
      // setThisReport(newProd.data)
      seloading(false)
    } catch (e) {
      seloading(false)
      // console.log(e)
    }
  }
  useEffect(() => {
    // console.log('reciepts', reciepts)
    const saved = saleReports.find(pr => (pr.smena_id == smena.id && pr.shop_id == shop.id && pr.status == 'Сохранен'))
    if (saved) {
      setNewSRID({
        id: saved.id,
        shop_id: saved.shop_id,
        smena_id: saved.smena_id
      })
      // console.log(saved.sclad, saved.reciepts)
      const nosortedsaved = saved.reciepts.map(forms => JSON.parse(forms))

      const sg = srform.reciepts.map(pr => {
        const item = JSON.parse(pr)
        const recip = reciepts.find(rr => rr.id == item.id)
        const test = nosortedsaved.find(pr => pr.id == item.id)
        if (test) {
          return test
        } else {
          return {
            ...item,
            price: recip.price,
            saleqty: 0,
            sold: 0,
            lostqty: 0,
            lostcomment: '',
            saleqty: 0,
            salecomment: '',
            sale10: 0,
            sale20: 0,
            sale30: 0,
            lostwithoutcup: 0,
            salewithoutcup: 0
          }
        }

      })

      setNewSR(sg)
      // setSmenaSclad(saved.sclad.map(forms => JSON.parse(forms)))

      // const sc = saved.sclad.map(forms => JSON.parse(forms))

      // const parsedSclad = sc.map(pr => {
      //   // const item = JSON.parse(pr)
      //   const scladsaved = sc.find(pr => pr.prod_id == item.prod_id)
      //   const prpr = item.prihod ? item.prihod : 0
      //   const prrs = item.rashod ? item.rashod : 0
      //   if (scladsaved) {
      //     return { ...item, prihod: prpr, rashod: prrs, fact: item.scldqty + prpr - prrs, andqty: item.scldqty + prpr - prrs }

      //   } else {

      //     return { ...item, prihod: prpr, rashod: prrs, fact: item.scldqty + prpr - prrs, andqty: item.scldqty + prpr - prrs }
      //   }
      // })
      // setSmenaSclad(saved.sclad.map(forms => JSON.parse(forms)))
    }
  }, [])



  const savesr = async () => {
    try {
      seloading(true)
      const refresh = await checkAuth()
      if (refresh) {
        // console.log(newSRID)
        const newProd = await $api.post(`${BACKURL}/api/salereports/save`,
          {
            smena_id: smena.id,
            newSRID: newSRID, newSR: newSR,
            smena: smena,
            admin: admin.id
          }

        )
        // console.log(newProd.data)
        const test = saleReports.find(pr => pr.id == newProd.data.saleReport)
        setNewSRID({
          id: newProd.data.saleReport.id,
          shop_id: newProd.data.saleReport.shop_id,
          smena_id: newProd.data.saleReport.smena_id
        })


        if (test) {
          setSaleReports(saleReports.map(pr => {
            if (pr.id == newProd.data.saleReport.id) {
              return newProd.data.saleReport
            } else {
              return pr
            }
          }))
        } else {
          setSaleReports([...saleReports, newProd.data.saleReport])
        }

        // console.log(newProd.body)

        setSmenas(smenas.map(pr => {
          if (pr.id == newProd.data.smena.id) {
            return newProd.data.smena
          } else return pr
        }))

        Notify.addNotification({
          title: "Готово!",
          message: "Сохранено, вы можете продолжить заполнять отчет в любой момент!",
          type: "success",
          insert: "bottom",
          container: "bottom-center",
          animationIn: ["animate__animated", "animate__fadeIn"],
          animationOut: ["animate__animated", "animate__fadeOut"],
          dismiss: {
            duration: 5000,
            onScreen: true
          }
        });
      }
      seloading(false)
      // setTimeout(()=>{
      //   Store.removeNotification(test)
      // },10000)
    } catch (e) {
      // console.log(e)
      seloading(false)
      Notify.addNotification({
        title: "Ошибка!",
        message: "Произошла непредвиденная ошибка!",
        type: "danger",
        insert: "bottom",
        container: "bottom-center",
        animationIn: ["animate__animated", "animate__fadeIn"],
        animationOut: ["animate__animated", "animate__fadeOut"],
        dismiss: {
          duration: 5000,
          onScreen: true
        }
      })
    }

  }
  const InnerAccordion = ({ contr, gt, list }) => {
    const adm = admins.find(pr => pr.id == gt.admin_id)
    console.log('gt', gt)
    return (
      <Accordion allowZeroExpanded style={{ width: '100%' }}>
        <AccordionItem>
          <AccordionItemHeading>
            <AccordionItemButton><>
              <div style={{ display: 'flex', flexDirection: "column", alignItems: 'center', justifyContent: 'space-evenly' }}>
                <div>
                  <b>{gt.kategory}</b>
                </div>
                <div style={{ width: '100%', justifyContent: 'start' }}>
                  <b>Администратор: </b>{adm.fullname}
                </div>
                <div style={{ width: '100%', justifyContent: 'start' }}>
                  <b>Поставщик: </b>{contr.name}
                </div>
                {Number(gt.nal) > 0 && (
                  <div style={{ width: '100%', justifyContent: 'start' }}>
                    <b>Оплата наличными: </b>{gt.nal}руб
                  </div>
                )}
                {Number(gt.beznal) > 0 && (
                  <div style={{ width: '100%', justifyContent: 'start' }}>
                    <b>Оплата по расчетному счету: </b>{gt.beznal}руб
                  </div>
                )}


              </div>

            </>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel style={{ background: 'wheat' }}>
            {(admin.role == 'Администратор' || admin.role == 'AllRights') && (


              <div style={{ display: 'flex', flexDirection: "row", alignItems: 'center', justifyContent: 'space-around' }}>
                {/* <Button text='Изменить' background='gold'
                  width='100%' height='30px'
                  onClick={(e) => {
                    setdate(pr.date)
                    setthisNakladnaya(gt)
                    seteditCARashod(true)
                  }} /> */}
                {/* {!selectedReport.confirm && (<> */}
                {/* <Button text='Изменить' background='orange'
                    width='30%' height='30px'
                    onClick={(e) => OpnaEditPrihoModal(gt.id)} /> */}

                <Button text='Удалить' background='red'
                  width='30%' height='30px'
                  onClick={(e) => submit(deleteRashod, 'Удалить накладную?', 'После удаления накладную нельзя будет восстановить!', gt.id)} />
                {/* </>)} */}

              </div>
            )}
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: "center", justifyContent: "center" }}>

              {list.map((product, index) => {
                // console.log(product)
                return <div style={{ display: 'flex', width: "100%", flexDirection: 'row', alignItems: "center", justifyContent: "space-between" }}>
                  <div>
                    <b>{index + 1})</b>
                  </div>
                  <div>
                    {product.name}
                  </div>
                  <div>
                    <b>{product.qty}</b>{product.mnt}
                  </div>


                </div>
              })}
            </div>

          </AccordionItemPanel>
        </AccordionItem>

      </Accordion>
    )
  };
  function customSort2(a, b) {
    const categoriesOrder = {
      'эспрессо': 1,
      'американо': 2,
      'капучино': 3,
      'латте': 4,
      'мокаччино': 5,
      'раф-кофе': 6,
      'флэт-уайт': 7,
      'вишнессо': 8,
      'какао': 9,
      'какао': 10,
      'айс латте': 11,

      'чай': 12,
      'сливки': 13,
      'сироп': 14,
      'мёд': 15,
      'маршмеллоу': 16,
      'лимон': 17,
      'растительное молоко': 18,
      'молоко': 19,

      'пунш': 19,
      'глинтвейн': 20,
      'вода': 21,
      'мини-сок': 22,
      'мохито': 23,
      'лимонад': 24,
      'сангрия': 25,
      'холодный мятный чай': 26,
      'choco pie': 27,
      'сладкая вата': 28,
      'milky way': 29,
      'резинка': 30,
      'панини': 31,
      'кекс': 32,
      'круассан': 33,
      'Прочее': 34,
    };

    const getCategory = (name) => {
      for (const category in categoriesOrder) {
        if ((name.toLowerCase()).includes(category)) {
          return category;
        }
      }
      return 'Прочее';
    };

    const categoryA = getCategory(a.name);
    const categoryB = getCategory(b.name);

    if (categoryA !== categoryB) {
      return categoriesOrder[categoryA] - categoriesOrder[categoryB];
    } else {
      return a.name.localeCompare(b.name);
    }
  }

  const coffee = newSR.filter(pr => pr.kategory == 'Кофемашина')
  const drincs = newSR.filter(pr => pr.kategory == 'Напитки без кофе')
  const nocoffee = newSR.filter(pr => pr.kategory != 'Кофемашина' && pr.kategory != 'Напитки без кофе')
  const cups = smenasclad.filter(pr => pr.kategory == 'Стаканы/Крышки')
  const nocups = smenasclad.filter(pr => pr.kategory != 'Стаканы/Крышки')



  coffee.sort(customSort2)
  drincs.sort(customSort2)
  nocoffee.sort(customSort2)
  let totlaMoney = 0
  let totalsale = 0
  let totalabom = 0
  let totallost = 0
  let totalsalewithoutcup = 0
  let totallostwithoutcup = 0
  for (let i = 0; i < newSR.length; i++) {
    totlaMoney = totlaMoney + newSR[i].sold * newSR[i].price
    totalsale = totalsale + (newSR[i].sale10 * 0.1 + newSR[i].sale20 * 0.2 + newSR[i].sale30 * 0.3) * newSR[i].price
    totallost = totallost + newSR[i].lostqty * newSR[i].price
    totalabom = totalabom + newSR[i].saleqty * newSR[i].price
    totallostwithoutcup = totallostwithoutcup + newSR[i].lostwithoutcup * newSR[i].price
    totalsalewithoutcup = totalsalewithoutcup + newSR[i].salewithoutcup * newSR[i].price

    if (newSR[i].linked) {
      for (let i2 = 0; i2 < newSR[i].linked.length; i2++) {
        totlaMoney = totlaMoney + newSR[i].linked[i2].sold * newSR[i].linked[i2].price
      }
    }
  }
  const confirm = async (id) => {

    try {
      seloading(true)

      const newProd = await $api.get(`${BACKURL}/api/incosations/confirm/${id}`)
      setIncosations(incosations.map(pr => {
        if (pr.id == id) {
          return newProd.data
        } else {
          return pr
        }
      }))
      // setIncosationsReport(incosations.filter(pr => {
      //   if (pr.id == id) {
      //     return newProd.data
      //   } else if (pr.avans_id == selectedReport.id) {
      //     return pr
      //   }
      // }))


      seloading(false)

    } catch (e) {
      // console.log(e)
      seloading(false)

    }

  }
  const confirmVnesenee = async (id) => {

    try {
      seloading(true)

      const newProd = await $api.get(`${BACKURL}/api/shopvneseneenal/confirm/${id}`)
      setShopvneseneenal(shopvneseneenal.map(pr => {
        if (pr.id == id) {
          return newProd.data
        } else {
          return pr
        }
      }))
      // setIncosationsReport(incosations.filter(pr => {
      //   if (pr.id == id) {
      //     return newProd.data
      //   } else if (pr.avans_id == selectedReport.id) {
      //     return pr
      //   }
      // }))


      seloading(false)

    } catch (e) {
      // console.log(e)
      seloading(false)

    }

  }
  const finish = async () => {
    try {
      seloading(true)



      // console.log('Продажи', newSR)
      // console.log('Продажи кофе + счетчики', coffee)
      // console.log('Расходы в эту смену', rashods)
      // console.log('Склад', smenasclad)
      // console.log('Смена', smena)
      // console.log('incosationsReport/', incosationsReport, vneseneeReport)

      const same = smenasclad.filter(pr => pr.comfirm == false)
      const cms = coffee.filter(pr => pr.awaited != pr.newqty && !pr.why)
      const scld = smenasclad.filter(pr => pr.awaited != pr.andqty && !pr.why)
      const incosationsReportNoConfirm = incosationsReport.some(pr => !pr.confirm)
      const vneseneeReportNoConfirm = vneseneeReport.some(pr => !pr.confirm)
      if (same.length == 0 && cms.length == 0 && scld.length == 0 && !incosationsReportNoConfirm && !vneseneeReportNoConfirm) {
        const refresh = await checkAuth()
        if (refresh) {
          const newProd = await $api.post(`${BACKURL}/api/salereports/finish/${smena.id}`,
            {
              newSRID: newSRID,
              newSR: newSR,
              kassa: kassa,
              smenasclad: smenasclad,
              admin: admin.id,
              shop_id: shop.id,
              total: Number((totlaMoney - totalsale).toFixed(2)),
              smena: smena,
              incosations_ids: incosationsReport.map(pr => pr.id),
              vnesenee_ids: vneseneeReport.map(pr => pr.id),
              kassa_ost: Number((Number
                (Number(kassa.money) +
                  Number(Number(totlaMoney - totalsale).toFixed(2))
                  - Number(smena.beznal) - on - summinc + sumVnesenee)).toFixed(2)),
              sumVnesenee: sumVnesenee,
              summinc: summinc,
              on: on,
              ob: ob
            }

          )
          const have = saleReports.some(pr => pr.id == newProd.data.id)

          setSaleReports(have ? saleReports.map(pr => {
            if (pr.id == newProd.data.sr.id) {
              return newProd.data.sr
            } else return pr
          }) : [...saleReports, newProd.data.sr])
          setShopKassas(shopKassas.map(pr => {
            if (pr.id == newProd.data.kassa.id) {
              return newProd.data.kassa
            } else return pr
          }))
          setSmenas(smenas.map(pr => {
            if (pr.id == newProd.data.smena.id) {
              return newProd.data.smena
            } else return pr
          }))
          // setComfirmReportModal(false)



          setSaleReportSteps(false)
          await CloseSmenaReturn()
        }
        Notify.addNotification({
          title: "Готово!",
          message: "Завершено! Отчет успешно отправлен!",
          type: "success",
          insert: "bottom",
          container: "bottom-center",
          animationIn: ["animate__animated", "animate__fadeIn"],
          animationOut: ["animate__animated", "animate__fadeOut"],
          dismiss: {
            duration: 5000,
            onScreen: true
          }
        });
      } else {
        Notify.addNotification({
          title: "Не все остатки подтверждены или не все комментарии об изменении счетчиков или остатков введены! Так же все инкассации и внесения в кассу должны быть подтверждены!",
          message: "Подтвердите все остатки на конец дня!",
          type: "warning",
          insert: "bottom",
          container: "bottom-center",
          animationIn: ["animate__animated", "animate__fadeIn"],
          animationOut: ["animate__animated", "animate__fadeOut"],
          dismiss: {
            duration: 5000,
            onScreen: true
          }
        });
      }

      seloading(false)



    } catch (e) {
      Notify.addNotification({
        title: "Ошибка!",
        message: "Произошла непредвиденная ошибка!",
        type: "danger",
        insert: "bottom",
        container: "bottom-center",
        animationIn: ["animate__animated", "animate__fadeIn"],
        animationOut: ["animate__animated", "animate__fadeOut"],
        dismiss: {
          duration: 5000,
          onScreen: true
        }
      })
    }

  }
  const deleteIt = async (id) => {
    try {
      seloading(true)

      const deleteProd = await $api.get(`${BACKURL}/api/incosations/delete/${id}`)
      setIncosations(incosations.filter(item => item.id != id))
      seloading(false)

      Notify.addNotification({
        title: "Готово!",
        message: "Инкассация успешно удалена из системы!",
        type: "success",
        insert: "bottom",
        container: "bottom-center",
        animationIn: ["animate__animated", "animate__fadeIn"],
        animationOut: ["animate__animated", "animate__fadeOut"],
        dismiss: {
          duration: 5000,
          onScreen: true
        }
      });
    } catch (e) {
      // console.log(e)
      seloading(false)

      Notify.addNotification({
        title: "Ошибка!",
        message: "Произошла непредвиденная ошибка!",
        type: "danger",
        insert: "bottom",
        container: "bottom-center",
        animationIn: ["animate__animated", "animate__fadeIn"],
        animationOut: ["animate__animated", "animate__fadeOut"],
        dismiss: {
          duration: 5000,
          onScreen: true
        }
      })
    }
  }
  const deleteItVnesenee = async (id) => {
    try {
      seloading(true)
      // shopvneseneenal, setShopvneseneenal
      const deleteProd = await $api.get(`${BACKURL}/api/shopvneseneenal/delete/${id}`)
      setShopvneseneenal(shopvneseneenal.filter(item => item.id != id))
      seloading(false)

      Notify.addNotification({
        title: "Готово!",
        message: "Инкассация успешно удалена из системы!",
        type: "success",
        insert: "bottom",
        container: "bottom-center",
        animationIn: ["animate__animated", "animate__fadeIn"],
        animationOut: ["animate__animated", "animate__fadeOut"],
        dismiss: {
          duration: 5000,
          onScreen: true
        }
      });
    } catch (e) {
      // console.log(e)
      seloading(false)

      Notify.addNotification({
        title: "Ошибка!",
        message: "Произошла непредвиденная ошибка!",
        type: "danger",
        insert: "bottom",
        container: "bottom-center",
        animationIn: ["animate__animated", "animate__fadeIn"],
        animationOut: ["animate__animated", "animate__fadeOut"],
        dismiss: {
          duration: 5000,
          onScreen: true
        }
      })
    }
  }
  const submit = async (func, titel, text, id) => {
    confirmAlert({
      title: titel,
      message: text,
      buttons: [
        {
          label: 'Да!',
          onClick: async () => await func(id)
        },
        {
          label: 'Отмена!',
          //   onClick: () => alert('Click No')
        }
      ],
      closeOnEscape: true,
      closeOnClickOutside: true,
    });
  };
  const OpnaEditModal = (id) => {
    setId(id)
    setEditShopIncasationsModal(true)
  }
  const Incasation = async () => {
    try {
      seloading(true)
      const ret = {
        // avans_id: thisReport.id,
        admin_id: admin.id,
        shop_id: shop.id,
        smena_id: smena.id,
        money: Number(summIncasations)
      }
      const newProd = await $api.post(`${BACKURL}/api/incosations/create`, ret)
      setIncosations([...incosations, newProd.data.incosation])
      // setThisReport(newProd.data.avansreport)
      // setIncosationsReport([...incosationsReport, newProd.data.incosation])
      // setAvansReports(avansReports.map(pr => {
      //   if (pr.id == newProd.data.avansreport.id) {
      //     return newProd.data.avansreport
      //   } else {
      //     return pr
      //   }
      // }))
      // console.log(admin.id,
      //   shop.id,
      //   smena.smena ? smena.id : thisReport.smena_id,
      //   summIncasations,
      //   newProd
      // )

      seloading(false)

    } catch (e) {
      // console.log(e)
      seloading(false)

    }
  }
  const Vnesenee = async () => {
    try {
      seloading(true)
      const ret = {
        // avans_id: thisReport.id,
        admin_id: admin.id,
        shop_id: shop.id,
        smena_id: smena.id,
        money: summVnesenee
      }
      const newProd = await $api.post(`${BACKURL}/api/shopvneseneenal/create`, ret)
      setShopvneseneenal([...shopvneseneenal, newProd.data.incosation])
      // setThisReport(newProd.data.avansreport)
      // setIncosationsReport([...incosationsReport, newProd.data.incosation])
      // setAvansReports(avansReports.map(pr => {
      //   if (pr.id == newProd.data.avansreport.id) {
      //     return newProd.data.avansreport
      //   } else {
      //     return pr
      //   }
      // }))
      // console.log(admin.id,
      //   shop.id,
      //   smena.smena ? smena.id : thisReport.smena_id,
      //   summIncasations,
      //   newProd
      // )

      seloading(false)

    } catch (e) {
      // console.log(e)
      seloading(false)

    }
  }

  return (
    <>
      {/* <ReactNotifications /> */}
      {saleReportSteps && (
        <div
          //  onClick={closeModal}
          id="c2ontainer12464qqqq" className={style.modal_container}
        // style={{backgroundImage: "url('../../../pages/auth/unnamed-2.jpg')"}}
        >
          <div className={style.borders2} style={{ height: 'inherit' }}>
            <h2 id={'select'} ref={ref} style={{ color: "white" }}> {shop.name}</h2>
            <h3 style={{ color: "white" }}>{(totlaMoney - totalsale).toFixed(2)} РУБ</h3>
            <div className={style.nextitem}>
              <div className={style.uuu} style={{ flexDirection: 'row' }}>
                <BiSolidSave style={{ color: "white" }} onClick={() => savesr()}></BiSolidSave>

              </div>
              {page != 'ACTION' && (
                < Button
                  text="Выход"
                  background="var(--primary-color)"
                  color="white"
                  width="100px"
                  onClick={() => {
                    savesr().then(() =>
                      setSaleReportSteps(false)
                    )


                  }}
                />)}

              < Button
                text="Отправить Отчёт"
                background="darkslateblue"
                color="white"
                width="100px"
                onClick={(e) => submit(finish, 'Отправить отчет?', 'Вы уверены, что хотите отправить отчет? Изменить его уже будет нельзя! Вы внимательно проверили данные?')}

              />
              {page == 'ACTION' && (
                < Button
                  text="Назад"
                  background="darkgreen"
                  color="white"
                  width="100px"
                  onClick={() => setPage('REPORT')}
                />)}
            </div>
            {page == 'REPORT' && (
              <div style={{ display: 'flex', width: "100%", flexDirection: 'column', textAlign: "center" }} >
                <Tabs >
                  <TabList>
                    <Tab style={{ background: 'none', border: 'none', color: "white" }} key={"Продажи"}><h5>Продажи</h5></Tab>

                    <Tab style={{ background: 'none', border: 'none', color: "white" }} key={'Счетчики'}><h5>Счетчики</h5></Tab>
                    <Tab style={{ background: 'none', border: 'none', color: "white" }} key={'Счетчики'}><h5>Расходы</h5></Tab>

                    <Tab style={{ background: 'none', border: 'none', color: "white" }} key={'Остатки'}><h5>Остатки</h5></Tab>
                    <Tab style={{ background: 'none', border: 'none', color: "white" }} key={"Продажи"}><h5>Выручка</h5></Tab>
                    <Tab style={{ background: 'none', border: 'none', color: "white" }} key={'Остатки'}><h5>Касса</h5></Tab>

                  </TabList>
                  {/* counters */}
                  <TabPanel>
                    <Tabs forceRenderTabPanel>
                      <TabList>
                        <Tab style={{ background: 'none', border: 'none', color: "white", opacity: "0.65" }} key={'Кофе'}><h6>Кофе</h6></Tab>
                        <Tab style={{ background: 'none', border: 'none', color: "white", opacity: "0.65" }} key={"Напитки"}><h6>Напитки</h6> </Tab>
                        <Tab style={{ background: 'none', border: 'none', color: "white", opacity: "0.65" }} key={'Прочее'}><h6>Прочее</h6> </Tab>
                      </TabList>

                      <TabPanel>
                        <div>
                          {coffee.map((cof, index) => {
                            // console.log(cof)
                            return (<>

                              <div className={style.itemdd} >
                                {/* <div style={{width:"100%"}}> */}
                                <div style={{ width: "50%" }}>{cof.name}</div>
                                <div style={{ width: "30%", display: "flex", justifyContent: "center", alignItems: 'center' }}>
                                  <FaMinus onClick={(e) => {

                                    setNewSR(newSR.map(pr => {
                                      if (pr.id == cof.id && pr.sold - 1 >= 0) {
                                        let addsolded = 0
                                        if (pr.linked.length > 0) {
                                          for (let i = 0; i < pr.linked.length; i++) {
                                            addsolded = addsolded + (Number(pr.linked[i].sold))

                                          }
                                        }
                                        return {
                                          ...pr,
                                          awaited: Number(pr.lostwithoutcup) + Number(pr.salewithoutcup) + Number(pr.oldqty) + Number(addsolded) + Number(pr.sold) + Number(pr.lostqty) + Number(pr.saleqty) - 1,

                                          newqty: Number(pr.lostwithoutcup) + Number(pr.salewithoutcup) + Number(pr.oldqty) + Number(addsolded) + Number(pr.sold) + Number(pr.lostqty) + Number(pr.saleqty) - 1,
                                          sold: pr.sold - 1
                                        }
                                      } else {
                                        return pr
                                      }
                                    }))
                                  }} />
                                  <div
                                    // value={cof.newqty-cof.oldqty}
                                    style={{ width: "30%", textAlign: "center" }}

                                    value={cof.sold} placeholder="Продано">
                                    {cof.sold}
                                  </div>
                                  <FaPlus onClick={(e) => {
                                    setNewSR(newSR.map(pr => {
                                      if (pr.id == cof.id && pr.sold + 1 >= 0) {
                                        let addsolded = 0
                                        if (pr.linked.length > 0) {
                                          for (let i = 0; i < pr.linked.length; i++) {
                                            addsolded = addsolded + (Number(pr.linked[i].sold))

                                          }
                                        }
                                        return {
                                          ...pr,
                                          awaited: Number(pr.lostwithoutcup) + Number(pr.salewithoutcup) + Number(pr.oldqty) + Number(addsolded) + Number(pr.sold) + Number(pr.lostqty) + Number(pr.saleqty) + 1,
                                          newqty: Number(pr.lostwithoutcup) + Number(pr.salewithoutcup) + Number(pr.oldqty) + Number(addsolded) + Number(pr.sold) + Number(pr.lostqty) + Number(pr.saleqty) + 1,
                                          sold: pr.sold + 1
                                        }
                                      } else {
                                        return pr
                                      }
                                    }))
                                  }} />
                                </div>
                                <div style={{ width: "20%" }}>{cof.sold * cof.price - cof.sale10 * 0.1 * cof.price - cof.sale20 * 0.2 * cof.price - cof.sale30 * 0.3 * cof.price}РУБ</div>

                              </div>
                              {/* {coffee.linked && (<> */}
                              {cof.linked.map(pr => {
                                const item = reciepts.find(prq => pr.id == prq.id)
                                // console.log('item',item,pr)
                                return (
                                  <div className={style.itemdd} >
                                    {/* <div style={{width:"100%"}}> */}
                                    <div style={{ width: "50%" }}>{item.name}</div>
                                    <div style={{ width: "30%", display: "flex", justifyContent: "center", alignItems: 'center' }}>

                                      <FaMinus onClick={(e) => {
                                        const newLinked = cof.linked.map(prAdd => {
                                          if (prAdd.id == pr.id) {
                                            return (
                                              {
                                                ...prAdd,
                                                price: item.price,
                                                sold: prAdd.sold - 1
                                              }
                                            )
                                          } else {
                                            return prAdd
                                          }
                                        })
                                        setNewSR(newSR.map(sr => {
                                          if (sr.id == cof.id) {
                                            let addsolded = 0
                                            if (sr.linked.length > 0) {
                                              for (let i = 0; i < sr.linked.length; i++) {
                                                addsolded = addsolded + (Number(sr.linked[i].sold))

                                              }
                                            }
                                            return {
                                              ...sr,
                                              awaited: Number(sr.lostwithoutcup) + Number(sr.salewithoutcup) + Number(sr.oldqty) + Number(addsolded) + Number(sr.sold) + Number(sr.lostqty) + Number(sr.saleqty) - 1,
                                              newqty: Number(sr.lostwithoutcup) + Number(sr.salewithoutcup) + Number(sr.oldqty) + Number(addsolded) + Number(sr.sold) + Number(sr.lostqty) + Number(sr.saleqty) - 1,
                                              linked: newLinked,
                                            }
                                          } else {
                                            return sr
                                          }
                                        }))
                                      }} />
                                      <div
                                        style={{ width: "30%", textAlign: "center" }}
                                        onChange={(e) => {
                                          // setNewSR(newSR.map(pr => {
                                          //   if (pr.id == cof.id) {
                                          //     return { ...pr, sold: e.target.value }
                                          //   } else {
                                          //     return pr
                                          //   }
                                          // }))
                                        }}

                                        value={pr.sold} placeholder="Продано">
                                        {pr.sold}
                                      </div>
                                      <FaPlus onClick={(e) => {
                                        const newLinked = cof.linked.map(prAdd => {
                                          if (prAdd.id == pr.id) {
                                            return (
                                              {
                                                ...prAdd,
                                                price: item.price,

                                                sold: prAdd.sold + 1
                                              }
                                            )
                                          } else {
                                            return prAdd
                                          }
                                        })
                                        setNewSR(newSR.map(sr => {
                                          if (sr.id == cof.id) {
                                            let addsolded = 0
                                            if (sr.linked.length > 0) {
                                              for (let i = 0; i < sr.linked.length; i++) {
                                                addsolded = addsolded + (Number(sr.linked[i].sold))

                                              }
                                            }
                                            return {
                                              ...sr,
                                              awaited: Number(sr.lostwithoutcup) + Number(sr.salewithoutcup) + Number(sr.oldqty) + Number(addsolded) + Number(sr.sold) + Number(sr.lostqty) + Number(sr.saleqty) + 1,
                                              newqty: Number(sr.lostwithoutcup) + Number(sr.salewithoutcup) + Number(sr.oldqty) + Number(addsolded) + Number(sr.sold) + Number(sr.lostqty) + Number(sr.saleqty) + 1,
                                              linked: newLinked,
                                            }
                                          } else {
                                            return sr
                                          }
                                        }))
                                      }} />
                                    </div>
                                    <div style={{ width: "20%" }}>{pr.sold * item.price}РУБ</div>

                                  </div>
                                )
                              })}
                              {/* </>)} */}
                            </>)
                          }
                          )}
                        </div>
                      </TabPanel>
                      <TabPanel>
                        <div>
                          {drincs.map((cof, index) => <div className={style.itemdd} >
                            {/* <div style={{width:"100%"}}> */}
                            <div style={{ width: "50%" }}>{cof.name}</div>
                            <div style={{ width: "30%", display: "flex", justifyContent: "center", alignItems: 'center' }}>
                              <FaMinus onClick={(e) => {
                                setNewSR(newSR.map(pr => {
                                  if (pr.id == cof.id && pr.sold - 1 >= 0) {
                                    return { ...pr, sold: pr.sold - 1 }
                                  } else {
                                    return pr
                                  }
                                }))
                              }} />
                              <div
                                style={{ width: "30%", textAlign: "center" }}
                                // onChange={(e) => {
                                //   setNewSR(newSR.map(pr => {
                                //     if (pr.id == cof.id) {
                                //       return { ...pr, sold: e.target.value }
                                //     } else {
                                //       return pr
                                //     }
                                //   }))
                                // }}
                                value={cof.sold} placeholder="Продано">
                                {cof.sold}
                              </div>
                              <FaPlus onClick={(e) => {
                                setNewSR(newSR.map(pr => {
                                  if (pr.id == cof.id && pr.sold + 1 >= 0) {
                                    return { ...pr, sold: pr.sold + 1 }
                                  } else {
                                    return pr
                                  }
                                }))
                              }} />
                            </div>
                            <div style={{ width: "20%" }}>{cof.sold * cof.price}РУБ</div>

                          </div>)}
                        </div>
                      </TabPanel>
                      <TabPanel>
                        <div>
                          {nocoffee.map((cof, index) => <div className={style.itemdd} >
                            {/* <div style={{width:"30%"}}> */}
                            <div style={{ width: "50%" }}>{cof.name}</div>
                            <div style={{ width: "30%", display: "flex", justifyContent: "center", alignItems: 'center' }}>
                              <FaMinus onClick={(e) => {
                                setNewSR(newSR.map(pr => {
                                  if (pr.id == cof.id && pr.sold - 1 >= 0) {
                                    return { ...pr, sold: pr.sold - 1 }
                                  } else {
                                    return pr
                                  }
                                }))
                              }} />
                              <div
                                style={{ width: "30%", textAlign: "center" }}
                                // onChange={(e) => {
                                //   setNewSR(newSR.map(pr => {
                                //     if (pr.id == cof.id) {
                                //       return { ...pr, sold: e.target.value }
                                //     } else {
                                //       return pr
                                //     }
                                //   }))
                                // }}
                                value={cof.sold} placeholder="Продано">
                                {cof.sold}

                              </div>
                              <FaPlus onClick={(e) => {
                                setNewSR(newSR.map(pr => {
                                  if (pr.id == cof.id && pr.sold + 1 >= 0) {
                                    return { ...pr, sold: pr.sold + 1 }
                                  } else {
                                    return pr
                                  }
                                }))
                              }} />
                            </div>
                            <div style={{ width: "20%" }}>{cof.sold * cof.price}РУБ</div>

                          </div>)}
                        </div>
                      </TabPanel>
                    </Tabs>
                  </TabPanel>
                  <TabPanel>
                    <div>
                      {coffee.map((cof, index) => {
                        // console.log(cof)
                        return (<>
                          <div className={style.itemdd} >
                            {/* <div style={{width:"100%"}}> */}
                            <div style={{ width: "40%" }}>{cof.name}</div>
                            <div style={{ width: "20%", opacity: "0.65" }}>{cof.oldqty}</div>
                            <div style={{ width: "20%" }}>
                              <input
                                style={{ width: "100%", textAlign: "center" }}
                                onChange={(e) => {
                                  setNewSR(newSR.map(pr => {
                                    if (pr.id == cof.id) {
                                      return { ...pr, newqty: e.target.value }
                                    } else {
                                      return pr
                                    }
                                  }))
                                }}
                                value={cof.newqty} placeholder="На конец дня">

                              </input>
                            </div>
                            <div style={{ width: "20%" }}>
                              <b>  <RiDiscountPercentFill style={{ fontSize: "30px", color: "#CD5A35" }} onClick={() => {
                                setactionId(cof)
                                setPage('ACTION')
                              }}></RiDiscountPercentFill></b></div>
                          </div>
                          {cof.awaited != cof.newqty && (<>
                            <div className={style.itemdd} >
                              <textarea
                                style={{ width: "100%", textAlign: "center", color: cof.awaited == cof.newqty ? 'black' : 'red' }}
                                onChange={(e) => {
                                  setNewSR(newSR.map(pr => {
                                    if (pr.id == cof.id) {
                                      return { ...pr, why: e.target.value }
                                    } else {
                                      return pr
                                    }
                                  }))
                                }}
                                value={cof.why} placeholder="Причина изменения счетчика">

                              </textarea>
                            </div>
                          </>)}
                        </>)
                      }

                      )}
                    </div>
                  </TabPanel>
                  <TabPanel>
                    <Button text='+' width='50px' background='gold'
                      onClick={() => {
                        // save(thisReport)
                        // setdate(pr.date)
                        setaddCARashod(true)
                      }}
                    />
                    {rashods.map(gt => {

                      const nakladnaya = gt
                      // console.log(gt,nakladnaya,contragentsPrihods)
                      const list = nakladnaya.list.map(oo => JSON.parse(oo))
                      const contr = contragents.find(pr => pr.id == nakladnaya.contragent_id)
                      // console.log(nakladnaya, list,contr)

                      return (
                        <>
                          <InnerAccordion contr={contr} gt={nakladnaya} list={list} />

                        </>
                      )
                    })}

                  </TabPanel>
                  <TabPanel style={{
                    transform: "scale(0.65)",
                    transformOrigin: "top left",
                    width: `${100 / 0.65}%`,
                    height: `${100 / 0.65}%`
                  }}>
                    <div style={{ height: '-webkit-fill-available' }}>
                      <div style={{ display: "flex", flexDirection: "row" }}>
                        <div style={{ width: "30%", color: "white" }}><b>Товар</b></div>
                        <div style={{ width: "10%", color: "white" }}><b>Утро</b></div>
                        <div style={{ width: "10%", color: "white" }}><b>+</b></div>
                        <div style={{ width: "10%", color: "white" }}><b>-</b></div>
                        <div style={{ width: "15%", color: "white" }}><b>Из продаж</b></div>
                        {/* <div style={{ width: "15%", color: "white" }}><b>Прогноз</b></div> */}

                        <div style={{ width: "15%", color: "white" }}><b>Факт Вечер</b></div>
                        <div style={{ width: "10%", color: "white" }}><b><FaCheck onClick={(e) => {
                          if (admin.role != "Администратор") {

                            setSmenaSclad(smenasclad.map(pr => {

                              return { ...pr, comfirm: !allSclad }


                            }))
                            setAllSclad(!allSclad)
                          }
                        }} /></b></div>
                      </div>
                      <div>
                        {nocups.map((cof, index) => {
                          // const rashodReciepts = allProductTaked.find(pr => Number(pr.prod_id) == cof.prod_id)
                          // // console.log(rashodReciepts)
                          // const t = rashodReciepts ? rashodReciepts : { qty: 0 }
                          const totalCounter = cof.awaited

                          return (<>
                            <div className={style.itemdd} style={{ backgroundColor: index % 2 === 0 ? 'white' : '#faf4eb' }}>

                              <div style={{ width: "30%" }}>{cof.name}</div>
                              <div style={{ width: "10%" }}>{cof.scldqty}</div>
                              <div style={{ width: "10%", borderRadius: '15px', marginLeft: '5px', marginRight: '5px', background: cof.prihod > 0 ? 'rgba(52, 255, 52, 0.45)' : 'white' }}>{cof.prihod}</div>
                              <div style={{ width: "10%", borderRadius: '15px', marginLeft: '5px', marginRight: '5px', background: cof.rashod > 0 ? 'rgba(255, 52, 59, 0.45)' : 'white' }}>{cof.rashod}</div>
                              <div style={{ width: "15%", borderRadius: '15px', marginLeft: '5px', marginRight: '5px', background: cof.rashodReciept != 0 ? 'rgba(238, 255, 52, 0.45)' : 'white' }}>{cof.rashodReciept}</div>
                              {/* <div style={{ width: "15%" }}>{cof.awaited}</div> */}

                              <div style={{ width: "15%" }}>
                                <input
                                  style={{ width: "100%", textAlign: "center", color: totalCounter == cof.andqty ? 'black' : 'red' }}
                                  onChange={(e) => {
                                    const regex = /^[0-9.]*$/;
                                    // if (regex.test(e.target.value)) {
                                    setSmenaSclad(smenasclad.map(pr => {
                                      if (pr.prod_id == cof.prod_id && pr.name == cof.name) {
                                        return { ...pr, andqty: e.target.value }
                                      } else {
                                        return pr
                                      }
                                    }))
                                    // }
                                  }}
                                  value={cof.andqty} placeholder="На конец дня">

                                </input>
                              </div>
                              {/* {totalCounter == cof.andqty && ( */}
                              <div style={{ width: "10%" }}
                                onClick={(e) => {
                                  setSmenaSclad(smenasclad.map(pr => {
                                    if (pr.prod_id == cof.prod_id && pr.name == cof.name) {
                                      return { ...pr, comfirm: pr.comfirm ? !pr.comfirm : true }
                                    } else {
                                      return pr
                                    }
                                  }))
                                }}
                                value={cof.comfirm}
                              >{cof.comfirm ? <FcOk style={{ height: '1.5em', width: '1.5em' }} /> : <MdOutlineRadioButtonUnchecked style={{ height: '1.5em', width: '1.5em' }} />}</div>
                              {/* )} */}

                            </div>
                            {totalCounter != cof.andqty && (<>
                              <div className={style.itemdd} >
                                <textarea
                                  style={{ width: "100%", textAlign: "center", color: totalCounter == cof.andqty ? 'black' : 'red' }}
                                  onChange={(e) => {
                                    // const regex = /^[0-9.]*$/;

                                    // if (regex.test(e.target.value)) {
                                    setSmenaSclad(smenasclad.map(pr => {
                                      if (pr.prod_id == cof.prod_id && pr.name == cof.name) {
                                        return { ...pr, why: e.target.value }
                                      } else {
                                        return pr
                                      }
                                    }))
                                    // }
                                  }}
                                  value={cof.why} placeholder="Причина изменения счетчика">

                                </textarea>
                              </div>
                            </>)}
                          </>)
                        })}
                      </div>
                      <div>
                        {cups.map((cof, index) => {
                          // const rashodReciepts = allProductTaked.find(pr => Number(pr.prod_id) == cof.prod_id)
                          // // console.log(rashodReciepts)
                          // const t = rashodReciepts ? rashodReciepts : { qty: 0 }
                          const totalCounter = cof.awaited

                          return (<>
                            <div className={style.itemdd} >

                              <div style={{ width: "30%" }}>{cof.name}</div>
                              <div style={{ width: "10%" }}>{cof.scldqty}</div>
                              <div style={{ width: "10%", borderRadius: '15px', marginLeft: '5px', marginRight: '5px', background: cof.prihod > 0 ? 'rgba(52, 255, 52, 0.45)' : 'white' }}>{cof.prihod}</div>
                              <div style={{ width: "10%", borderRadius: '15px', marginLeft: '5px', marginRight: '5px', background: cof.rashod > 0 ? 'rgba(255, 52, 59, 0.45)' : 'white' }}>{cof.rashod}</div>
                              <div style={{ width: "15%", borderRadius: '15px', marginLeft: '5px', marginRight: '5px', background: cof.rashodReciept != 0 ? 'rgba(238, 255, 52, 0.45)' : 'white' }}>{cof.rashodReciept}</div>
                              {/* <div style={{ width: "15%" }}>{cof.awaited}</div> */}

                              <div style={{ width: "15%" }}>
                                <input
                                  style={{ width: "100%", textAlign: "center", color: totalCounter == cof.andqty ? 'black' : 'red' }}
                                  onChange={(e) => {
                                    const regex = /^[0-9.]*$/;
                                    // if (regex.test(e.target.value)) {
                                    setSmenaSclad(smenasclad.map(pr => {
                                      if (pr.prod_id == cof.prod_id && pr.name == cof.name) {
                                        return { ...pr, andqty: e.target.value }
                                      } else {
                                        return pr
                                      }
                                    }))
                                    // }
                                  }}
                                  value={cof.andqty} placeholder="На конец дня">

                                </input>
                              </div>
                              {/* {totalCounter == cof.andqty && ( */}
                              <div style={{ width: "10%" }}
                                onClick={(e) => {
                                  setSmenaSclad(smenasclad.map(pr => {
                                    if (pr.prod_id == cof.prod_id && pr.name == cof.name) {
                                      return { ...pr, comfirm: pr.comfirm ? !pr.comfirm : true }
                                    } else {
                                      return pr
                                    }
                                  }))
                                }}
                                value={cof.comfirm}
                              >{cof.comfirm ? <FcOk style={{ height: '1.5em', width: '1.5em' }} /> : <MdOutlineRadioButtonUnchecked style={{ height: '1.5em', width: '1.5em' }} />}</div>
                              {/* )} */}

                            </div>
                            {totalCounter != cof.andqty && (<>
                              <div className={style.itemdd} >
                                <textarea
                                  style={{ width: "100%", textAlign: "center", color: totalCounter == cof.andqty ? 'black' : 'red' }}
                                  onChange={(e) => {
                                    // const regex = /^[0-9.]*$/;

                                    // if (regex.test(e.target.value)) {
                                    setSmenaSclad(smenasclad.map(pr => {
                                      if (pr.prod_id == cof.prod_id && pr.name == cof.name) {
                                        return { ...pr, why: e.target.value }
                                      } else {
                                        return pr
                                      }
                                    }))
                                    // }
                                  }}
                                  value={cof.why} placeholder="Причина изменения остатка">

                                </textarea>
                              </div>
                            </>)}
                          </>)
                        })}
                      </div>
                    </div>
                  </TabPanel>

                  <TabPanel>
                    {/* <table style={{ width: '100%' }}> */}

                    <div style={{ color: 'black', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', overflowX: 'hidden' }}>

                      <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        {/* <div style={{ width: '33%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <b>Дата</b>
                      </div> */}
                        <div style={{ width: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center', color: 'white' }}>
                          <b>Менеджер</b>
                        </div>
                        <div style={{ width: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center', color: 'white' }}>
                          <b>Часы</b>
                        </div>
                      </div>




                      <div
                        style={{ width: '100%', marginBottom: '15px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>

                        {/* <div style={{ width: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <h5>{formatDate(thisReport.createdAt)}</h5>
                      </div> */}
                        <div style={{ width: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center', color: 'white' }}>
                          <h5>{admin.fullname}</h5>
                        </div>
                        <div style={{ width: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                          <input
                            type="number"
                            inputMode="decimal" // для открытия цифровой клавиатуры на мобильных устройствах
                            pattern="^\d*\.?\d{0,2}$" // дополнительная валидация
                            step="1" // шаг ввода для ограничения на два знака после запятой
                            min="0" // минимальное значение
                            className={style.kassainput}
                            onChange={(e) => {
                              setSmenas(smenas.map(pr => {
                                if (pr.id == smena.id) {
                                  return { ...pr, hours: e.target.value }
                                } return pr
                              }))
                              // const newavansReports = avansReports.map(pr1 => {

                              //   if (pr1.id == selectedReport.id) {
                              //     // setThisReport({ ...thisReport, revenues: { ...revenues, hours: e.target.value } })
                              //     return { ...thisReport, revenues: { ...revenues, hours: e.target.value } }
                              //   } else {
                              //     return pr1
                              //   }
                              // })
                              // // console.log(newavansReports)
                              // setAvansReports(newavansReports)
                            }}
                            // disabled={thisReport.status == "Открыт" ? false : true}
                            value={smena.hours}
                            style={{ width: "50px" }} placeholder="Часы" />
                        </div>
                      </div>
                      <div style={{ width: '100%', marginBottom: '15px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>

                        <div style={{ width: '33%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                          <label style={{ color: 'white' }}>Z-Отчет</label>
                          <input

                            className={style.kassainput}
                            value={Number(totlaMoney - totalsale).toFixed(2)} style={{ width: "80%" }} placeholder="Наличные" disabled />
                        </div>
                        <div style={{ width: '33%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                          <label style={{ color: 'white' }}>Наличные</label>

                          <input

                            className={style.kassainput}
                            value={(Number(Number(totlaMoney - totalsale).toFixed(2)) - Number(smena.beznal)).toFixed(2)}
                            style={{ width: "80%" }} placeholder="Наличные" disabled />
                        </div>
                        <div style={{ width: '33%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                          <label style={{ color: 'white' }}>Безнал</label>

                          <input
                            type="number"
                            inputMode="decimal" // для открытия цифровой клавиатуры на мобильных устройствах
                            pattern="^\d*\.?\d{0,2}$" // дополнительная валидация
                            step="0.01" // шаг ввода для ограничения на два знака после запятой
                            min="0" // минимальное значение
                            className={style.kassainput}
                            // disabled={thisReport.status == "Открыт" ? false : true}

                            onChange={(e) => {
                              setSmenas(smenas.map(pr => {
                                if (pr.id == smena.id) {
                                  return { ...pr, beznal: e.target.value }
                                } return pr
                              }))
                              //   const newavansReports = avansReports.map(pr1 => {

                              //     if (pr1.id == selectedReport.id) {
                              //       // setThisReport({ ...thisReport, revenues: { ...revenues, beznal: e.target.value } })
                              //       return { ...thisReport, revenues: { ...revenues, beznal: e.target.value } }
                              //     } else {
                              //       return pr1
                              //     }
                              //   })
                              //   // console.log(newavansReports)
                              //   setAvansReports(newavansReports)
                            }}




                            value={smena.beznal}
                            style={{ width: "80%" }} placeholder="Безнал" />
                        </div>
                      </div>


                      <hr style={{ width: '100%', marginBottom: '15px', border: '1px black solid' }} />




                    </div>
                    {/* </tbody>
                  </table> */}
                  </TabPanel>
                  <TabPanel>
                    <h2 style={{ color: 'white' }}>Касса на начало дня</h2>
                    <input value={kassa.money} className={style.kassainput} placeholder="Касса на начало недели" />

                    <h2 style={{ color: 'white', marginTop: '40px' }}>Израсходовано всего</h2>
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', marginTop: '40px' }}>
                      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                        <label>Наличные</label>
                        <input value={on ? on : 0} style={{ width: '40%' }} className={style.kassainput} placeholder="Наличные" />

                      </div>
                      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                        <label>Безналичные</label>

                        <input value={ob ? ob : 0} style={{ width: '40%' }} className={style.kassainput} placeholder="Безналичные" />

                      </div>


                    </div>

                    <h2 style={{ color: 'white', marginTop: '40px' }}>Касса на конец дня</h2>
                    <input value={(Number(kassa.money) + Number(Number(Number(totlaMoney - totalsale).toFixed(2)) - Number(smena.beznal)) - on).toFixed(2)} className={style.kassainput} placeholder="Касса на конец недели" />



                    <h2 style={{ color: 'white', marginTop: '40px' }}>Инкасированно</h2>
                    {incosationsReport.length == 0 && (
                      <input value={'Нет инкасаций'} disabled={admin.role !== 'Администратор' && admin.role !== 'AllRights'} className={style.kassainput} placeholder="Инкасированно" />

                    )}
                    {incosationsReport.length > 0 && (
                      <>
                        <div style={{ display: 'flex', flexDirection: 'column', width: '100%', alignItems: 'center', justifyContent: 'center' }}>

                          <div style={{ display: 'flex', flexDirection: 'row', width: '100%', alignItems: 'center', justifyContent: 'center' }}>

                            <div style={{ display: 'flex', flexDirection: 'row', width: '30%', alignItems: 'center', justifyContent: 'center' }}>
                              <b>Инкассатор</b>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'row', width: '30%', alignItems: 'center', justifyContent: 'center' }}>
                              <b>Сумма</b>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'row', width: '30%', alignItems: 'center', justifyContent: 'center' }}>
                              <b>Подтвердить</b>
                            </div>
                          </div>




                          {incosationsReport.map((pr) => {
                            const adm = admins.find(a => a.id == pr.admin_id)
                            // const emp = admins.find(a => a.id == pr.employee_id)
                            // const sh = shops.find(a => a.id == pr.shop_id)
                            if (pr) {
                              return <>
                                <div style={{ display: 'flex', color: 'white', flexDirection: 'row', width: '100%', alignItems: 'center', justifyContent: 'center' }}>

                                  <div style={{ display: 'flex', color: 'white', flexDirection: 'row', width: '30%', alignItems: 'center', justifyContent: 'center' }}>
                                    {adm.fullname}
                                  </div>

                                  <div style={{ display: 'flex', color: 'white', flexDirection: 'row', width: '30%', alignItems: 'center', justifyContent: 'center' }}>
                                    {pr.money}руб
                                  </div>
                                  <div style={{ display: 'flex', color: 'white', flexDirection: 'row', width: '30%', alignItems: 'center', justifyContent: 'center' }}>
                                    {!pr.confirm && admin.role == 'Бариста' && <Button text='Подтвердить'
                                      background='gold'
                                      width='100%' height='30px'
                                      onClick={() => {
                                        submit(confirm, 'Инкассация', 'После подтверждения инкассации, сумму изменить будет невозможно!', pr.id)
                                        // confirm(pr.id)
                                        // }

                                      }} />}

                                    {!pr.confirm && admin.role != 'Бариста' && <>
                                      <Button text='Изменить' background='gold'
                                        width='100%' height='30px'
                                        onClick={() => {
                                          OpnaEditModal(pr.id)
                                        }} />
                                      <Button text='Удалить' background='gold'
                                        width='100%' height='30px'
                                        onClick={() => {
                                          submit(deleteIt, 'Удалить?', 'Удалить инкассацию из системы?', pr.id)
                                        }} />
                                    </>}
                                    {pr.confirm && (<>Подтверждено</>)}
                                  </div>         </div>

                              </>

                            }
                          })}

                        </div>
                      </>

                    )}
                    <div style={{ display: 'flex', marginTop: '40px', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>

                      {(admin.role == 'Администратор' || admin.role == 'AllRights') && (
                        <>
                          <input type="number" inputMode="decimal" value={summIncasations} onChange={(e) => {

                            // if (summIncasations >= 0) {
                            setSummIncasations(Number(e.target.value))

                            // }

                          }}

                            className={style.kassainput} placeholder="Сумма Инкассации" />

                          <Button text={incosationsReport.length == 0 ? 'Инкасировать' : 'Инкасировать ещё'} background='gold'
                            width='200px' height='30px'
                            onClick={() => {


                              // save(thisReport)
                              submit(Incasation, 'Инкассация', `Инкассировать ${summIncasations}руб?`)

                              // Incasation()
                            }} />
                        </>
                      )}
                    </div>
                    <h2 style={{ color: 'white', marginTop: '40px' }}>Внесено</h2>
                    {vneseneeReport.length == 0 && (
                      <input value={'Нет поступлений'} disabled={admin.role !== 'Администратор' && admin.role !== 'AllRights'} className={style.kassainput} placeholder="Инкасированно" />

                    )}
                    {vneseneeReport.length > 0 && (
                      <>
                        <div style={{ display: 'flex', flexDirection: 'column', width: '100%', alignItems: 'center', justifyContent: 'center' }}>

                          <div style={{ display: 'flex', flexDirection: 'row', width: '100%', alignItems: 'center', justifyContent: 'center' }}>

                            <div style={{ display: 'flex', flexDirection: 'row', width: '30%', alignItems: 'center', justifyContent: 'center' }}>
                              <b>Инкассатор</b>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'row', width: '30%', alignItems: 'center', justifyContent: 'center' }}>
                              <b>Сумма</b>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'row', width: '30%', alignItems: 'center', justifyContent: 'center' }}>
                              <b>Подтвердить</b>
                            </div>
                          </div>




                          {vneseneeReport.map((pr) => {
                            const adm = admins.find(a => a.id == pr.admin_id)
                            // const emp = admins.find(a => a.id == pr.employee_id)
                            // const sh = shops.find(a => a.id == pr.shop_id)
                            if (pr) {
                              return <>
                                <div style={{ display: 'flex', color: 'white', flexDirection: 'row', width: '100%', alignItems: 'center', justifyContent: 'center' }}>

                                  <div style={{ display: 'flex', color: 'white', flexDirection: 'row', width: '30%', alignItems: 'center', justifyContent: 'center' }}>
                                    {adm.fullname}
                                  </div>

                                  <div style={{ display: 'flex', color: 'white', flexDirection: 'row', width: '30%', alignItems: 'center', justifyContent: 'center' }}>
                                    {pr.money}руб
                                  </div>
                                  <div style={{ display: 'flex', color: 'white', flexDirection: 'row', width: '30%', alignItems: 'center', justifyContent: 'center' }}>
                                    {!pr.confirm && admin.role == 'Бариста' && <Button text='Подтвердить'
                                      background='gold'
                                      width='100%' height='30px'
                                      onClick={() => {
                                        submit(confirmVnesenee, 'Внесенее неличных', 'После подтверждения внесения, сумму изменить будет невозможно!', pr.id)
                                        // confirm(pr.id)
                                        // }

                                      }} />}

                                    {!pr.confirm && admin.role != 'Бариста' && <>
                                      <Button text='Изменить' background='gold'
                                        width='100%' height='30px'
                                        onClick={() => {
                                          // OpnaEditModal(pr.id)
                                        }} />
                                      <Button text='Удалить' background='gold'
                                        width='100%' height='30px'
                                        onClick={() => {
                                          submit(deleteItVnesenee, 'Удалить?', 'Удалить внесенее в кассу из системы?', pr.id)
                                        }} />
                                    </>}
                                    {pr.confirm && (<>Подтверждено</>)}
                                  </div>         </div>

                              </>

                            }
                          })}

                        </div>
                      </>

                    )}

                    <div style={{ display: 'flex', marginTop: '40px', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>

                      {(admin.role == 'Администратор' || admin.role == 'AllRights') && (
                        <>
                          <input type="number" inputMode="decimal"  value={summVnesenee} onChange={(e) => {
                            // summVnesenee, setSummVnesenee
                            // if (summIncasations >= 0) {
                            setSummVnesenee(Number(e.target.value))

                            // }

                          }}

                            className={style.kassainput} placeholder="Сумма Внесения" />

                          <Button text={vneseneeReport.length == 0 ? 'Внести наличные в кассу' : 'Внести ещё'} background='gold'
                            width='200px' height='30px'
                            onClick={() => {


                              // save(thisReport)
                              submit(Vnesenee, 'Внесение наличных в кассу', `Внести ${summVnesenee}руб в кассу?`)

                              // Incasation()
                            }} />
                        </>
                      )}
                    </div>

                    <h2 style={{ color: 'white', marginTop: '40px' }}>Остаток в кассе</h2>
                    <input value={Number((Number
                      (Number(kassa.money) + Number(Number(totlaMoney - totalsale).toFixed(2)) - Number(smena.beznal) - on - summinc + sumVnesenee)).toFixed(2))} className={style.kassainput} placeholder="Остаток в кассе" />

                  </TabPanel>

                </Tabs >


              </div>
            )}
            {page == 'ACTION' && (
              <div style={{ display: 'flex', width: "100%", flexDirection: 'column', textAlign: "center" }} >
                <h3 style={{ color: "white" }}>{actionId.name}</h3>
                <h4 style={{ color: "white" }}>{actionId.sold * actionId.price - actionId.sale10 * 0.1 * actionId.price - actionId.sale20 * 0.2 * actionId.price - actionId.sale30 * 0.3 * actionId.price}РУБ</h4>
                <hr style={{ border: "none", margin: "15px 0", backgroundColor: "brown", height: "px" }} />
                <h5 style={{ color: "white" }}>Абонементы</h5>

                <div style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: 'center', flexDirection: "row" }}>
                  <div style={{ width: "50%", display: "flex", justifyContent: "center", alignItems: 'center', flexDirection: "row" }}>

                    <FaMinus style={{ color: 'white', fontSize: '20px' }} onClick={(e) => {

                      setNewSR(newSR.map(pr => {

                        if (pr.id == actionId.id && actionId.saleqty - 1 >= 0) {
                          setactionId({ ...actionId, saleqty: actionId.saleqty - 1 })
                          let addsolded = 0
                          if (pr.linked.length > 0) {
                            for (let i = 0; i < pr.linked.length; i++) {
                              addsolded = addsolded + (Number(pr.linked[i].sold))

                            }
                          }
                          return {
                            ...pr,

                            awaited: Number(pr.lostwithoutcup) + Number(pr.salewithoutcup) + Number(pr.oldqty) + Number(addsolded) + Number(pr.sold) + Number(pr.lostqty) + Number(pr.saleqty) - 1,

                            newqty: Number(pr.lostwithoutcup) + Number(pr.salewithoutcup) + Number(pr.oldqty) + Number(addsolded) + Number(pr.sold) + Number(pr.lostqty) + Number(pr.saleqty) - 1,
                            saleqty: actionId.saleqty - 1
                          }
                        } else {
                          return pr
                        }
                      }))
                      // console.log(newSR)
                    }} />
                    <div
                      // value={cof.newqty-cof.oldqty}
                      style={ieconStyle}
                    >
                      {actionId.saleqty}
                    </div>
                    <FaPlus style={{ color: 'white', fontSize: '20px' }} onClick={(e) => {
                      // console.log(actionId)
                      setNewSR(newSR.map(pr => {
                        if (pr.id == actionId.id && actionId.saleqty + 1 >= 0) {
                          setactionId({ ...actionId, saleqty: actionId.saleqty + 1 })
                          let addsolded = 0
                          if (pr.linked.length > 0) {
                            for (let i = 0; i < pr.linked.length; i++) {
                              addsolded = addsolded + (Number(pr.linked[i].sold))

                            }
                          }
                          return {
                            ...pr,
                            awaited: Number(pr.lostwithoutcup) + Number(pr.salewithoutcup) + Number(pr.oldqty) + Number(addsolded) + Number(pr.sold) + Number(pr.lostqty) + Number(pr.saleqty) + 1
                            , newqty: Number(pr.lostwithoutcup) + Number(pr.salewithoutcup) + Number(pr.oldqty) + Number(addsolded) + Number(pr.sold) + Number(pr.lostqty) + Number(pr.saleqty) + 1,
                            saleqty: actionId.saleqty + 1
                          }
                        } else {
                          return pr
                        }
                      }))
                    }} />

                  </div>

                  <div style={{ width: "50%", display: "flex", justifyContent: "center", alignItems: 'center' }}>
                    <textarea placeholder="Абонементы"
                      value={actionId.salecomment}
                      onChange={(e) => {
                        setNewSR(newSR.map(pr => {
                          if (pr.id == actionId.id) {
                            setactionId({ ...actionId, salecomment: e.target.value })

                            return { ...pr, salecomment: e.target.value }
                          } else {
                            return pr
                          }
                        }))
                      }}>

                    </textarea>
                  </div>
                </div>
                <hr style={{ border: "none", margin: "15px 0", backgroundColor: "darkred", height: "3px" }} />
                <div>
                  <h5 style={{ color: "white" }}>Карты Скидок</h5>

                  <div style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: 'center', flexDirection: "row" }}>
                    <div style={{ width: "27%", margin: '3%', display: "flex", justifyContent: "center", alignItems: 'center', flexDirection: "column" }}>
                      <h5>10%</h5>
                      <div style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: 'center', flexDirection: "row" }}>
                        <FaMinus style={{ color: 'white', fontSize: '20px' }} onClick={(e) => {
                          // console.log(actionId)
                          setNewSR(newSR.map(pr => {
                            if (pr.id == actionId.id && actionId.sale10 - 1 >= 0) {
                              setactionId({ ...actionId, sale10: actionId.sale10 - 1 })

                              return { ...pr, sale10: actionId.sale10 - 1 }
                            } else {
                              return pr
                            }
                          }))
                          // console.log(actionId)
                        }} />
                        <div
                          // value={cof.newqty-cof.oldqty}
                          style={ieconStyle}
                        >
                          {actionId.sale10 ? actionId.sale10 : 0}
                        </div>
                        <FaPlus style={{ color: 'white', fontSize: '20px' }} onClick={(e) => {
                          // console.log(actionId)

                          setNewSR(newSR.map(pr => {
                            if (pr.id == actionId.id && actionId.sale10 + 1 >= 0) {
                              setactionId({ ...actionId, sale10: actionId.sale10 + 1 })

                              return { ...pr, sale10: actionId.sale10 + 1 }
                            } else {
                              return pr
                            }
                          }))
                        }} />
                      </div>
                    </div>
                    <div style={{ width: "27%", margin: '3%', display: "flex", justifyContent: "center", alignItems: 'center', flexDirection: "column" }}>
                      <h5>20%</h5>

                      <div style={{ width: "100%%", display: "flex", justifyContent: "center", alignItems: 'center', flexDirection: "row" }}>
                        <FaMinus style={{ color: 'white', fontSize: '20px' }} onClick={(e) => {
                          setNewSR(newSR.map(pr => {
                            if (pr.id == actionId.id && actionId.sale20 - 1 >= 0) {
                              setactionId({ ...actionId, sale20: actionId.sale20 - 1 })

                              return { ...pr, sale20: actionId.sale20 - 1 }
                            } else {
                              return pr
                            }
                          }))
                        }} />
                        <div
                          // value={cof.newqty-cof.oldqty}
                          style={ieconStyle}
                        >
                          {actionId.sale20 ? actionId.sale20 : 0}
                        </div>
                        <FaPlus style={{ color: 'white', fontSize: '20px' }} onClick={(e) => {
                          setNewSR(newSR.map(pr => {
                            if (pr.id == actionId.id && actionId.sale20 + 1 >= 0) {
                              setactionId({ ...actionId, sale20: actionId.sale20 + 1 })

                              return { ...pr, sale20: actionId.sale20 + 1 }
                            } else {
                              return pr
                            }
                          }))
                        }} />
                      </div>
                    </div>
                    <div style={{ width: "27%", margin: '3%', display: "flex", justifyContent: "center", alignItems: 'center', flexDirection: "column" }}>
                      <h5 >30%</h5>

                      <div style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: 'center', flexDirection: "row" }}>
                        <FaMinus style={{ color: 'white', fontSize: '20px' }} onClick={(e) => {
                          setNewSR(newSR.map(pr => {
                            if (pr.id == actionId.id && actionId.sale30 - 1 >= 0) {
                              setactionId({ ...actionId, sale30: actionId.sale30 - 1 })

                              return { ...pr, sale30: actionId.sale30 - 1 }
                            } else {
                              return pr
                            }
                          }))
                        }} />
                        <div
                          // value={cof.newqty-cof.oldqty}
                          style={ieconStyle}
                        >
                          {actionId.sale30 ? actionId.sale30 : 0}
                        </div>
                        <FaPlus style={{ color: 'white', fontSize: '20px' }} onClick={(e) => {
                          setNewSR(newSR.map(pr => {
                            if (pr.id == actionId.id && actionId.sale30 + 1 >= 0) {
                              setactionId({ ...actionId, sale30: actionId.sale30 + 1 })

                              return { ...pr, sale30: actionId.sale30 + 1 }
                            } else {
                              return pr
                            }
                          }))
                        }} />
                      </div>
                    </div>
                  </div>
                </div>
                <hr style={{ border: "none", margin: "15px 0", backgroundColor: "darkred", height: "3px" }} />
                <h5 style={{ color: "white" }}>Списано</h5>
                <div style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: 'center', flexDirection: "row" }}>

                  <div style={{ width: "50%", display: "flex", justifyContent: "center", alignItems: 'center' }}>

                    <FaMinus style={{ color: 'white', fontSize: '20px' }} onClick={(e) => {
                      setNewSR(newSR.map(pr => {
                        if (pr.id == actionId.id && actionId.lostqty - 1 >= 0) {
                          setactionId({ ...actionId, lostqty: actionId.lostqty - 1 })
                          let addsolded = 0
                          if (pr.linked.length > 0) {
                            for (let i = 0; i < pr.linked.length; i++) {
                              addsolded = addsolded + (Number(pr.linked[i].sold))

                            }
                          }
                          return {
                            ...pr,
                            awaited: Number(pr.lostwithoutcup) + Number(pr.salewithoutcup) + Number(pr.oldqty) + Number(addsolded) + Number(pr.sold) + Number(pr.lostqty) + Number(pr.saleqty) - 1,

                            newqty: Number(pr.lostwithoutcup) + Number(pr.salewithoutcup) + Number(pr.oldqty) + Number(addsolded) + Number(pr.sold) + Number(pr.lostqty) + Number(pr.saleqty) - 1,
                            lostqty: actionId.lostqty - 1
                          }
                        } else {
                          return pr
                        }
                      }))
                    }} />
                    <div
                      // value={cof.newqty-cof.oldqty}
                      style={ieconStyle}
                    >
                      {actionId.lostqty ? actionId.lostqty : 0}
                    </div>
                    <FaPlus style={{ color: 'white', fontSize: '20px' }} onClick={(e) => {
                      setNewSR(newSR.map(pr => {
                        if (pr.id == actionId.id && actionId.lostqty + 1 >= 0) {
                          setactionId({ ...actionId, lostqty: actionId.lostqty + 1 })
                          let addsolded = 0
                          if (pr.linked.length > 0) {
                            for (let i = 0; i < pr.linked.length; i++) {
                              addsolded = addsolded + (Number(pr.linked[i].sold))

                            }
                          }
                          return {
                            ...pr,

                            awaited: Number(pr.lostwithoutcup) + Number(pr.salewithoutcup) + Number(pr.oldqty) + Number(addsolded) + Number(pr.sold) + Number(pr.lostqty) + Number(pr.saleqty) + 1,

                            newqty: Number(pr.lostwithoutcup) + Number(pr.salewithoutcup) + Number(pr.oldqty) + Number(addsolded) + Number(pr.sold) + Number(pr.lostqty) + Number(pr.saleqty) + 1,
                            lostqty: actionId.lostqty + 1
                          }
                        } else {
                          return pr
                        }
                      }))
                    }} />

                  </div>

                  <div style={{ width: "50%", display: "flex", justifyContent: "center", alignItems: 'center' }}>
                    <textarea placeholder="Причина"
                      value={actionId.lostcomment}
                      onChange={(e) => {
                        setNewSR(newSR.map(pr => {
                          if (pr.id == actionId.id) {
                            setactionId({ ...actionId, lostcomment: e.target.value })

                            return { ...pr, lostcomment: e.target.value }
                          } else {
                            return pr
                          }
                        }))
                      }}>

                    </textarea>
                  </div>
                </div>
                <hr style={{ border: "none", margin: "15px 0", backgroundColor: "darkred", height: "3px" }} />
                <div>
                  <h5 style={{ color: "white" }}>Списано на сотрудника без стакана</h5>
                  <div style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: 'center' }}>

                    <FaMinus style={{ color: 'white', fontSize: '20px' }} onClick={(e) => {
                      setNewSR(newSR.map(pr => {
                        if (pr.id == actionId.id && actionId.lostwithoutcup - 1 >= 0) {
                          setactionId({ ...actionId, lostwithoutcup: actionId.lostwithoutcup - 1 })
                          let addsolded = 0
                          if (pr.linked.length > 0) {
                            for (let i = 0; i < pr.linked.length; i++) {
                              addsolded = addsolded + (Number(pr.linked[i].sold))

                            }
                          }
                          return {
                            ...pr,

                            awaited: Number(pr.lostwithoutcup) + Number(pr.salewithoutcup) + Number(pr.oldqty) + Number(addsolded) + Number(pr.sold) + Number(pr.lostqty) + Number(pr.saleqty) - 1,

                            newqty: Number(pr.lostwithoutcup) + Number(pr.salewithoutcup) + Number(pr.oldqty) + Number(addsolded) + Number(pr.sold) + Number(pr.lostqty) + Number(pr.saleqty) - 1,
                            lostwithoutcup: actionId.lostwithoutcup - 1
                          }
                        } else {
                          return pr
                        }
                      }))
                    }} />
                    <div
                      // value={cof.newqty-cof.oldqty}
                      style={ieconStyle}
                    >
                      {actionId.lostwithoutcup ? actionId.lostwithoutcup : 0}
                    </div>
                    <FaPlus style={{ color: 'white', fontSize: '20px' }} onClick={(e) => {
                      setNewSR(newSR.map(pr => {
                        if (pr.id == actionId.id && actionId.lostwithoutcup + 1 >= 0) {
                          setactionId({ ...actionId, lostwithoutcup: actionId.lostwithoutcup + 1 })
                          let addsolded = 0
                          if (pr.linked.length > 0) {
                            for (let i = 0; i < pr.linked.length; i++) {
                              addsolded = addsolded + (Number(pr.linked[i].sold))

                            }
                          }
                          return {
                            ...pr,

                            awaited: Number(pr.lostwithoutcup) + Number(pr.salewithoutcup) + Number(pr.oldqty) + Number(addsolded) + Number(pr.sold) + Number(pr.lostqty) + Number(pr.saleqty) + 1,

                            newqty: Number(pr.lostwithoutcup) + Number(pr.salewithoutcup) + Number(pr.oldqty) + Number(addsolded) + Number(pr.sold) + Number(pr.lostqty) + Number(pr.saleqty) + 1,
                            lostwithoutcup: actionId.lostwithoutcup + 1
                          }
                        } else {
                          return pr
                        }
                      }))
                    }} />

                  </div>


                </div>
                <hr style={{ border: "none", margin: "15px 0", backgroundColor: "darkred", height: "3px" }} />
                <div>
                  <h5 style={{ color: "white" }}>Продано без стакана</h5>
                  <div style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: 'center' }}>

                    <FaMinus style={{ color: 'white', fontSize: '20px' }} onClick={(e) => {
                      setNewSR(newSR.map(pr => {
                        if (pr.id == actionId.id) {
                          setactionId({ ...actionId, salewithoutcup: actionId.salewithoutcup - 1 })
                          let addsolded = 0
                          if (pr.linked.length > 0) {
                            for (let i = 0; i < pr.linked.length; i++) {
                              addsolded = addsolded + (Number(pr.linked[i].sold))

                            }
                          }
                          return {
                            ...pr,

                            awaited: Number(pr.lostwithoutcup) + Number(pr.salewithoutcup) + Number(pr.oldqty) + Number(addsolded) + Number(pr.sold) + Number(pr.lostqty) + Number(pr.saleqty) - 1,

                            newqty: Number(pr.lostwithoutcup) + Number(pr.salewithoutcup) + Number(pr.oldqty) + Number(addsolded) + Number(pr.sold) + Number(pr.lostqty) + Number(pr.saleqty) - 1,
                            salewithoutcup: actionId.salewithoutcup - 1
                          }
                        } else {
                          return pr
                        }
                      }))
                    }} />
                    <div
                      // value={cof.newqty-cof.oldqty}
                      style={ieconStyle}
                    >
                      {actionId.salewithoutcup ? actionId.salewithoutcup : 0}
                    </div>
                    <FaPlus style={{ color: 'white', fontSize: '20px' }} onClick={(e) => {
                      setNewSR(newSR.map(pr => {
                        if (pr.id == actionId.id) {
                          setactionId({ ...actionId, salewithoutcup: actionId.salewithoutcup + 1 })
                          let addsolded = 0
                          if (pr.linked.length > 0) {
                            for (let i = 0; i < pr.linked.length; i++) {
                              addsolded = addsolded + (Number(pr.linked[i].sold))

                            }
                          }
                          return {
                            ...pr,

                            awaited: Number(pr.lostwithoutcup) + Number(pr.salewithoutcup) + Number(pr.oldqty) + Number(addsolded) + Number(pr.sold) + Number(pr.lostqty) + Number(pr.saleqty) + 1,

                            newqty: Number(pr.lostwithoutcup) + Number(pr.salewithoutcup) + Number(pr.oldqty) + Number(addsolded) + Number(pr.sold) + Number(pr.lostqty) + Number(pr.saleqty) + 1,
                            salewithoutcup: actionId.salewithoutcup + 1
                          }
                        } else {
                          return pr
                        }
                      }))
                    }} />

                  </div>


                </div>
              </div>
            )}
            {/* {page == 'FINISH' && (
              <div style={{ display: 'flex', width: "100%", flexDirection: 'column', textAlign: "center" }} >
              
              </div>
            )} */}
          </div>

        </div >
      )}
      {
        loading && (
          <Loading loading background="rgba(255, 165, 0,0.75)" loaderColor="#3498db"></Loading>
        )
      }
      {editShopIncasationsModal && (
        <EditShopIncasationsModal id={id} />)}
      {
        addCARashod && (
          <AddContrAgentsRashodModal
            // date={date}
            smena_id={smena.id}
            // setThisReport={setThisReport}
            avansreport_id={newSR.id}
            shop_id={shop.id}></AddContrAgentsRashodModal>
        )
      }

    </>
  )
}
export default SaleReportSteps;